import { render } from "./headers.vue?vue&type=template&id=c09ddf5e"
import script from "./headers.vue?vue&type=script&lang=js"
export * from "./headers.vue?vue&type=script&lang=js"

import "./headers.vue?vue&type=style&index=0&id=c09ddf5e&lang=css"

import exportComponent from "/Users/yunusemresogut/Desktop/ishesap-partner/bayi_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__